<template>
    <popup :opened="dataToShow > 0" @close="close" overflow="overflow-hidden">        
        <div class="py-5 md:py-15 md:px-20 lg:px-10 xl:px-40 2xl:py-20 2xl:px-32">
            <div v-if="dataToShow === 1">
                <h3 class="mb-10">Choisir le type de CV</h3>
                <div class="2xl:mx-28 grid grid-cols-2 justify-center md:space-x-5 items-start pr-5">
                    <!-- BEGIN CLASSIQUE -->
                    <div class="col-span-1 flex flex-col h-48 md:h-88 w-max group">
                        <div>
                            <div class="text-center mb-5">Classique</div>
                            <div class="relative">
                                <!-- Filigrane -->
                                <div 
                                    class="top-0 left-0 absolute w-full h-40 md:h-80 rounded-md z-20 cursor-pointer transition-all duration-700 bg-transparent bg-opacity-0 group-hover:bg-indigo-600 group-hover:bg-opacity-25"
                                    @click.stop="chooseType(constants.CV_TYPES.BASIC)" 
                                >
                                </div>
                                <!-- END Filigrane -->
                                <img src="/assets/img/cv/cv_classic.png" alt="" class="h-40 md:h-80 object-contain border border-gray-600 border-opacity-25 rounded-lg" />
                            </div>
                        </div>
                    </div>
                    <!-- END CLASSIQUE -->

                    <!-- BEGIN DASHBOARD -->
                    <div class="col-span-1 flex flex-col relative w-max group">
                        <div class="w-max">
                            <div class="text-center mb-5">Dashboard</div>

                            <div class="relative">
                                <!-- Filigrane -->
                                <div 
                                    class="top-0 left-0 absolute w-full h-28 md:h-56 rounded-md z-20 cursor-pointer transition-all duration-700 bg-transparent bg-opacity-0 group-hover:bg-indigo-600 group-hover:bg-opacity-25"
                                    @click.stop="chooseType(constants.CV_TYPES.DASHBOARD)" 
                                >
                                </div>
                                <!-- END Filigrane -->
                                <img src="/assets/img/cv/cv_dashboard.png" alt="" class="h-28 md:h-56 object-contain border border-gray-600 border-opacity-25 rounded-lg" />
                            </div>
                        </div>
                    </div>
                    <!-- END DASHBOARD -->
                </div>
            </div>
            
            <div v-if="dataToShow === 2">
                <h3 class="mb-10">Créer un nouveau CV {{cv.type === 'dashboard' ? 'dashboard' : ''}}</h3>

                <form class="flex flex-col items-center mb-5" autocomplete="off" @submit.prevent="createNewCv()">
                    <input-text
                        name="title"
                        libelle="Titre de mon CV"
                        :value="cv.title" @input="(newValue) => {cv.title = newValue}"
                        :error="true"
                        :msg-error="error"
                        class="lg:w-1/2 mb-5"
                        :maxlength="50"
                    />

                    <div class="flex justify-center">
                        <div
                            class="w-max-content w-max"
                        >
                            <action-button
                                border-color="border-transparent"
                                text-color="text-white"
                                :bg-color="saving ? 'bg-gray-600' : 'bg-pink-600'"
                                :bg-color-square="saving ? 'bg-gray-600' : 'bg-pink-600'"
                                libelle="Créer un nouveau CV"
                                :type-shadow="saving ? 'shadow-gray' : 'shadow-pink'"
                                @clickAction="createNewCv()"
                            />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </popup>
</template>

<script>
import Popup from './../../../components/Popup';
import ActionButton from './../../../components/ActionButton';
import InputText from './../../../components/Inputs/InputText';
import Icon from './../../../components/Icon';

import Constants from './../../../constants';
import VueHtml2pdf from 'vue-html2pdf';
import ModelPdf from './../pdf/ModelPdf.vue';

export default {
  name:'CreateNewCvPopup',

  props:{
    dataToShow: Number,
    errors: Object,
    saving:{
      type:Boolean,
      required:false,
      default:false,
    },
  },

  data() {
    return {
      cv:{
        type: Constants.CV_TYPES.BASIC,
        title:'',
        description: ''
      },
      error:'',
      constants: Constants,
    };
  },

  components:{
    Popup,
    ActionButton,
    InputText,
    Icon,
    VueHtml2pdf,
    ModelPdf,
  },

  computed:{
    //
  },

  methods:{

    close(){
      this.$emit('close');
      this.cv = {
        title:'',
        description: '',
      };
      this.error='';
    },

    createNewCv(){
      if(!this.cv.title || this.cv.title === ''){
        this.error = 'Veuillez renseigner un titre pour votre CV';
        return;
      }
      this.$emit('createNewCv', this.cv);
      this.close();
    },

    changePage(step){
      this.$emit('changePage', step);
    },

    chooseType(typeCv){
      this.cv.type = typeCv;

      this.changePage(2);
    }
  }
};
</script>
